module.exports = __webpack_public_path__ + "img/weixin.61db7318.png";